import {
  useGetTrainingTasksApiV1TrainingTasksGet,
  useModelTrainingActionsApiV1TrainingTasksTrainingTaskIdPatch,
} from "../../../../vl-api/vlComponents";
import { App } from "antd";
import { useQueryClient } from "@tanstack/react-query";
import { invalidateActiveQueryByOperationId } from "../../../../vl-api/vlUtils";
import last from "lodash/last";
import { TrainingTask } from "../../../../vl-api/vlSchemas";
import { CheckCircleOutlined } from "@ant-design/icons";
import styles from "./TrainModel.module.scss";

const POLLING_INTERVAL_MS = 2000;

export const useTrainingTasks = (datasetId: string) => {
  const { notification, modal } = App.useApp();
  const queryClient = useQueryClient();
  const { data, isLoading, isError } =
    useGetTrainingTasksApiV1TrainingTasksGet<{
      tasks: any[];
    }>(
      {
        queryParams: { dataset_id: datasetId },
      },
      {
        refetchInterval: ({ state }) => {
          if (last(state.data?.tasks)?.status === "IN_PROGRESS") {
            return POLLING_INTERVAL_MS;
          }
        },
      },
    );
  const modelTrainingActionsMutation =
    useModelTrainingActionsApiV1TrainingTasksTrainingTaskIdPatch({
      onSuccess: () => {
        notification.success({ message: "Training canceled" });
        invalidateActiveQueryByOperationId(
          queryClient,
          "getTrainingTasksApiV1TrainingTasksGet",
        );
      },
    });
  const handleCancelTaskClick = (taskId: string) => {
    modal.confirm({
      title: "Cancel training",
      content: "Are you sure you want to cancel training?",
      okText: "Yes",
      onOk: () =>
        modelTrainingActionsMutation.mutate({
          pathParams: { trainingTaskId: taskId },
          queryParams: { action: "CANCEL" },
        }),
      cancelText: "No",
    });
  };

  const handleCompletedClick = (onViewModelClick: () => void) => {
    modal.confirm({
      title: <div className={styles.successColor}>Training Completed</div>,
      content:
        "Your model has been created successfully. You can explore it in the Model Catalog.",
      okText: "View Model",
      onOk: onViewModelClick,
      icon: <CheckCircleOutlined className={styles.successColor} />,
      closable: true,
      cancelButtonProps: { style: { display: "none" } },
    });
  };

  return {
    handleCancelTaskClick,
    handleCompletedClick,
    task: last<TrainingTask>(data?.tasks),
    isLoading,
    isError,
  };
};
